import CreateUser from "./CreateUser";
import Table from "../../../components/Table";
import React, { useState, useRef, useEffect } from "react";
import DynamicDropdown from "../../../components/Dropdown";
import ContextMenu from "../../../components/ContextMenu";
import { getallusers } from "../../../services/user-management/user-management";
import { toast } from "../../../components/AppToast";
import transformUserData from "../../../utils/transformUserData";

const Users = () => {
  const [editData, setEditData] = useState(null);
  const [addNewData, setAddNewData] = useState(false);
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, rowData: null });
  const gridRef = useRef();
  const [colData, setColData] = useState([]);

  const ExportDropdownData = [
    { value: "CSV", label: "Export as CSV" },
    // { value: "Excel", label: "Export as Excel" }
  ];




  const [userData, setUserData] = useState([]);
  const fetchUsers = async () => {
    try {
      const data = await getallusers();

      setUserData(transformUserData(data) || []);

      setColData(Object.keys(data[0]));

    } catch (err) {
      // toast.error(`Failed to fetch users: ${err}`);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);



  const handleEdit = () => {
    console.log(contextMenu.rowData);
    
    setEditData(contextMenu.rowData);
    setContextMenu({ ...contextMenu, visible: false });
  };

  const handleToggle = () => {
    setUserData(userData.map(user =>
      user._id === contextMenu.rowData._id ? { ...user, status: !user.status } : user))
    setContextMenu({ ...contextMenu, visible: false });

  };

  const AddButtonRenderer = (props) => {
    const iconRef = useRef();

    const handleIconClick = () => {
      if (iconRef.current) {
        const rect = iconRef.current.getBoundingClientRect();
        setContextMenu({
          visible: true,
          x: rect.right,
          y: rect.bottom,
          rowData: props.data,
        });
      }
    };

    return (
      <div className="d-flex align-items-center justify-content-center w-100 h-100">
        <i
          ref={iconRef}
          className="bi bi-three-dots-vertical admin-grid-action-icon"
          role="button"
          tabIndex={0}
          title="Actions"
          aria-label="Open row actions"
          onClick={handleIconClick}
          onKeyDown={(e) => e.key === 'Enter' && handleIconClick()}
        />
      </div>
    );
  };

  function generateColumnDefs(columns) {
    const transformColData = columns
      .filter((key) => key !== '_id' && key !== 'countryCode' && key !== 'updatedAt' && key !== '__v')
      .map((key) => {
        const formattedKey = key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (str) => str.toUpperCase())
          .trim();

        const colDef = {
          field: key,
          headerName: formattedKey,
        };

        if (key === 'status') {
          colDef.cellRenderer = (params) => {
            const v = params.value;
            if (v == null || v === '') return null;
            const s = String(v);
            const label = s.replace(/^[✅🚫⏳]\s*/u, '').trim();
            const active = s.includes('Active');
            const inactive = s.includes('Inactive');
            const pending = s.includes('Pending');
            let cls = 'text-bg-secondary';
            if (active) cls = 'text-bg-success';
            else if (inactive) cls = 'text-bg-danger';
            else if (pending) cls = 'text-bg-warning';
            return (
              <span className={`badge rounded-pill px-2 py-1 fw-medium ${cls}`} style={{ fontSize: '0.75rem' }}>
                {label || s}
              </span>
            );
          };
          colDef.maxWidth = 200;
        }

        if (key === 'userType') {
          colDef.cellRenderer = (params) => {
            const v = params.value;
            if (v == null || v === '') return null;
            return (
              <span
                className="badge rounded-pill px-2 py-1 fw-medium border admin-user-type-badge"
                style={{ fontSize: '0.75rem' }}
              >
                {String(v)}
              </span>
            );
          };
          colDef.maxWidth = 170;
        }

        return colDef;
      });

    return [
      ...transformColData,
      {
        field: 'action',
        headerName: 'Actions',
        cellRenderer: AddButtonRenderer,
        width: 88,
        maxWidth: 88,
        sortable: false,
        filter: false,
      },
    ];
  }

  const onCancelhandler = (value) => {
    value && setEditData(null);
    value && setAddNewData(false);
  };

  const columnDefs = generateColumnDefs(colData);

  const handleExport = (type) => {
    if (!gridRef.current) return;
    if (type === "CSV") {
      gridRef.current.api.exportDataAsCsv();
    } else if (type === "Excel") {
      if (gridRef.current.api.exportDataAsExcel) {
        gridRef.current.api.exportDataAsExcel();
      } else {
        // alert("Excel export requires ag-Grid Enterprise.");
      }
    }
  };

  const handleAddNew = () => {
    setAddNewData(!addNewData);
  };

  useEffect(() => {

  }, []);

  const showList = !editData && !addNewData;

  return (
    <div className="card shadow-lg main-card admin-tenant-card admin-user-page" style={{ position: 'relative' }}>
      <div className="card-header admin-tenant-card__header text-white border-0">
        {showList ? (
          <>
            <h4 className="mb-0 fw-semibold">User management</h4>
            <p className="mb-0 mt-1 small opacity-75">Directory of portal users — add accounts or use the row menu to edit and change access.</p>
          </>
        ) : (
          <h4 className="mb-0 fw-semibold">{addNewData ? 'Add new user' : 'Update user'}</h4>
        )}
      </div>
      <div className="card-body">
        {showList && (
          <div className="table-navbar d-flex align-items-center mb-3 gap-2 flex-wrap">
            <button
              type="button"
              className="add-button btn btn-sm fw-semibold rounded-pill px-3 d-inline-flex align-items-center gap-2"
              onClick={handleAddNew}
            >
              <i className="bi bi-plus-lg" aria-hidden />
              Add user
            </button>
            <DynamicDropdown
              options={ExportDropdownData}
              onSelect={(option) => handleExport(option.value)}
              placeholder={'Export'}
              className="dropdown-menu-right"
            />
          </div>
        )}
        {/* Table or Form */}
        {showList && (
          <Table
            rowData={userData}
            columnDefs={columnDefs}
            gridOptions={{
              suppressHorizontalScroll: true,
              getRowClass: params => params.data && params.data.status === false ? 'row-deactivated' : '',
            }}
            gridRef={gridRef}
            wrapClassName="admin-tenant-grid-wrap"
          />
        )}

        {addNewData && (
          <CreateUser
            onSubmit={(data) => {
              // console.log("Create:", data);
            }}
            submitText="Create User"
            cancelText="Cancel"
            onCancel={onCancelhandler}
          />
        )}
        {editData && (
          <CreateUser
            initialValues={editData}
            onSubmit={(data) => {
              // console.log("Update:", data);
            }}
            submitText="Update User"
            cancelText="Cancel"
            onCancel={onCancelhandler}
          />
        )}
      </div>
      <ContextMenu
        visible={contextMenu.visible}
        x={contextMenu.x}
        y={contextMenu.y}
        onClose={() => setContextMenu((prev) => ({ ...prev, visible: false }))}
        items={[
          {
            label: 'Edit',
            onClick: handleEdit,
          },
          {
            label: !contextMenu.rowData?.status ? 'Active' : 'Deactivate',
            onClick: handleToggle,
          },
        ]}
      />
    </div>
  );
};

export default Users;
